import { createSelector } from "reselect";
import {
  getVariantType,
  getAlt,
  getChromosome,
  getGenome,
  getPosition,
  getRef,
} from "./general.selectors";

const getSubmissionRefresh = (state) => state.clinvarSubmissionListRefresh;

const getUserClinvarApiKey = (state) =>
  state.user && state.user.clinvar_submission_api_key;

const getUserClinvarApiKeyHash = (state) =>
  state.user && state.user.clinvar_submission_token_id_hashed;

const getMainTranscript = (state) =>
  state.variantResult && state.variantResult.mainTranscript;

const getHgvsNotationForClinvarSubmission = createSelector(
  getMainTranscript,
  (mainTranscript) => {
    if (mainTranscript && mainTranscript.hgvs) {
      const cValue = mainTranscript.hgvs;
      const hgvsCdot = `${mainTranscript.name}:${cValue}`;
      if (hgvsCdot.match(/^ENST/i)) {
        return null;
      }
      return hgvsCdot;
    }
    return null;
  }
);

const getChromosomeCoordinates = createSelector(
  getVariantType,
  getChromosome,
  getPosition,
  getRef,
  getAlt,
  getGenome,
  (vType, chr, pos, ref, alt, genome) => {
    // const refLength = ref ? ref.length : 0;
    // const altLength = alt ? alt.length : 0;
    // if (vType === "SVN") {
    //   return {
    //     chr: chr && chr.substring(3),
    //     start: pos,
    //     ref,
    //     alt,
    //     assembly: genome && genome.name,
    //   };
    // }
    // if (vType === "Substitution" && refLength < 51 && altLength < 51) {
    //   return {
    //     chr: chr && chr.substring(3),
    //     start: pos,
    //     ref,
    //     alt,
    //     assembly: genome && genome.name,
    //   };
    // }
    return {
      chr: chr && chr.substring(3),
      // start: pos,
      ref: ref ?? "-",
      alt: alt ?? "-",
      assembly: genome && genome.name,
    };
  }
);

const getClinvarSubmissions = (state) =>
  state.clinvarSubmissions && state.clinvarSubmissions;

const getClinvarSubmissionById = (state, { submissionId }) => {
  if (submissionId) {
    return (
      state.clinvarSubmissions &&
      state.clinvarSubmissions.find((e) => e.submission_id === submissionId)
    );
  }
  return null;
};

const getClinvarNotation = (state) => {
  return state.variantResult && state.variantResult.clinvar_notation;
};

// We will replace getHgvsNotationForClinvarSubmission once thalia part is implemented.
const getHgvsNotationClinvarNotation = createSelector(
  getClinvarNotation,
  (clinvarNotation) => {
    if (
      clinvarNotation &&
      clinvarNotation.transcript &&
      clinvarNotation.hgvs_c_dot
    ) {
      const { transcript, hgvs_c_dot: cDot } = clinvarNotation;
      const hgvsCdot = `${transcript}:${cDot}`;
      if (hgvsCdot.match(/^ENST/i)) {
        return null;
      }
      return hgvsCdot;
    }
    return null;
  }
);

// We will replace getHgvsNotationForClinvarSubmission once thalia part is implemented.
const getChromosomeCoordinatesClinvarNotation = createSelector(
  getClinvarNotation,
  (clinvarNotation) => {
    if (clinvarNotation) {
      const {
        chromosome,
        start_position: startPosition,
        end_position: endPosition,
        reference,
        alternative,
        genome,
        variant_type: variantType,
      } = clinvarNotation;
      return {
        chr: chromosome && chromosome.substring(3),
        start: startPosition,
        stop: endPosition,
        ref: reference || "-",
        alt: alternative || "-",
        assembly: genome,
        variantType,
      };
    }
    return null;
  }
);

export {
  getUserClinvarApiKey,
  getUserClinvarApiKeyHash,
  getMainTranscript,
  getHgvsNotationForClinvarSubmission,
  getClinvarSubmissions,
  getClinvarSubmissionById,
  getChromosomeCoordinates,
  getSubmissionRefresh,
  getClinvarNotation,
  getHgvsNotationClinvarNotation,
  getChromosomeCoordinatesClinvarNotation,
};
